<template>
  <div>
    <h2>
      Consignment
    </h2>
    <el-form
      ref="form"
      v-loading="isSaving"
      :rules="rules"
      :model="formData"
    >
      <el-row>
        <el-col>
          <el-form-item
            label="Prefix Required"
            prop="prefixRequired"
          >
            <el-switch
              v-model="formData.prefixRequired"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item
            label="Total Length (including prefix)"
            prop="length"
          >
            <el-input
              v-model="formData.length"
              type="number"
              placeholder="10"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Prefix Format"
          >
            <el-input
              v-model="formData.prefixDef"
              placeholder="TIG+ChargeAccount"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row :gutter="15">
        <el-col :span="12">
          <el-form-item
            label="Minimum Number Format"
            prop="minDef"
          >
            <el-input
              v-model="formData.minDef"
              type="number"
              placeholder="0"
            />
          </el-form-item>
        </el-col>
        <el-col :span="12">
          <el-form-item
            label="Maximum Number Format"
            prop="maxDef"
          >
            <el-input
              v-model="formData.maxDef"
              type="number"
              placeholder="999999"
            />
          </el-form-item>
        </el-col>
      </el-row>
      <el-row>
        <el-col :span="12">
          <el-form-item
            label="External Quoting Template"
            prop="quote_template"
          >
            <el-input
              v-model="formData.quote_template"
            />
          </el-form-item>
        </el-col>
      </el-row>
    </el-form>
  </div>
</template>
<script>
export default {
  props: {
    formData: {
      type: Object,
      default: null,
      required: true
    }
  },
  data () {
    return {
      rules: {
        length: [
          { required: true, message: 'Total Length is required.', trigger: 'blur' }
        ],
        prefixDef: [
          { required: true, message: 'Prefix Format is required.', trigger: 'blur' }
        ],
        minDef: [
          { required: true, message: 'Minimum Number Format is required.', trigger: 'blur' }
        ],
        maxDef: [
          { required: true, message: 'Maximum Number Format is required.', trigger: 'blur' }
        ]
      },
      isSaving: false
    }
  }
}
</script>
